import React, { useState, useEffect, useRef, useContext } from "react";
import GenderForm from "./components/genderForm";
import BirthdayForm from "./components/birthdayForm";
import EmailForm from "./components/emailForm";
import NameForm from "./components/nameForm";
import PasswordForm from "./components/passwordForm";
import PromoStep from "./components/promoStep";
import { EVENTS_SIGN_IN, landingId } from "./constants";
import { simplyClick, getTTI, sendScreenResolution } from "./helpers";
import { createPortal } from "react-dom";
import PopUp from "./components/PopUp";
import { ContextProfileUser } from "./lib/profileContext";
import { useSessionData } from "ui-components";
import { Footer } from "./components/Footer";
import { useAppendLandingId } from "./hooks/useAppendLandingId";

function App() {
  const [step, setStep] = useState(1);
  let content = null;
  const [showPopUp, setShowPopUp] = useState(false);
  const speedRef = useRef(0.5);

  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);
  const footer = document.getElementById("footer");

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useAppendLandingId(landingId);

  useEffect(() => {
    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".login-btn");
    const search = window.location.search;
    const lndId =
      search === ""
        ? `?landing_id=${landingId}`
        : `${search}&landing_id=${landingId}`;

    if (signInButton) {
      signInButton.setAttribute("href", `/login${lndId}`);
    }
  }, []);

  useEffect(() => {
    const signInButton = document.querySelector(".login-btn");

    const handleClick = () => {
      const eventName = EVENTS_SIGN_IN[step - 1];
      if (eventName) {
        simplyClick(eventName);
      }
    };

    signInButton?.addEventListener("click", handleClick);
    return () => signInButton?.removeEventListener("click", handleClick);
  }, [step]);

  const openPopUp = (e) => {
    if (e.target.classList.contains("content__wrapper")) {
      setShowPopUp(true);
      simplyClick("cl_lnd_photos", { text: `step(${step})` }, false);
    }
  };

  useEffect(() => {
    const wrapper = document.querySelector(".content__wrapper");
    wrapper?.addEventListener("click", openPopUp);

    return () => wrapper?.removeEventListener("click", openPopUp);
  }, [step]);

  useEffect(() => {
    const wrapper = document.querySelector(".content__wrapper");
    if (!wrapper) return;
    let position = 0;
    let lastTimestamp = performance.now();
    let animationFrameId;
    const animateBg = (timestamp) => {
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      position += speedRef.current * (elapsed / 16);
      wrapper.style.backgroundPosition = `${position}px 56px`;
      animationFrameId = requestAnimationFrame(animateBg);
    };
    animationFrameId = requestAnimationFrame(animateBg);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const closePopUp = () => {
    setShowPopUp(false);
  };

  switch (step) {
    case 2:
      content = <GenderForm nextStep={() => setStep(3)} />;
      break;
    case 3:
      content = <BirthdayForm nextStep={() => setStep(4)} />;
      break;
    case 4:
      content = <NameForm nextStep={() => setStep(5)} />;
      break;
    case 5:
      content = <EmailForm nextStep={() => setStep(6)} />;
      break;
    case 6:
      content = <PasswordForm nextStep={() => setStep(7)} />;
      break;
    default:
      content = (
        <>
          <PromoStep
            nextStep={() => {
              setStep(2);
              simplyClick("cl_lnd_match_me");
            }}
          />
        </>
      );
      break;
  }

  return (
    <>
      {showPopUp &&
        document.getElementById("root") &&
        createPortal(
          <PopUp step={step} closePopUp={closePopUp} />,
          document.getElementById("root")
        )}
      {content}
      {footer && createPortal(<Footer step={step} />, footer)}

    </>
  );
}

export default App;
